import './scripts/common';
import {onFind} from "./libs/@elements/init-modules-in-scope";

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]', function (element) {
    new Popover(element, {})
});

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as ajaxForm from './libs/@elements/ajax-form';
ajaxForm.init();

import * as affix from './libs/@elements/affix';
affix.init();